export default __webpack_public_path__ + "static/serti-halal-97355236c21c22e2ebd2af46af1e84ec.png";